import React from 'react';
import PropTypes from 'prop-types';

function IconEdit({ size = 16, color = `#8C8C8C`, className, style }) {
  return (
    <svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.2075 4.58547L11.4144 1.79297C11.3215 1.70009 11.2113 1.62641 11.0899 1.57614C10.9686 1.52587 10.8385 1.5 10.7072 1.5C10.5758 1.5 10.4458 1.52587 10.3244 1.57614C10.2031 1.62641 10.0929 1.70009 10 1.79297L2.29312 9.49985C2.19986 9.59237 2.12592 9.70251 2.0756 9.82386C2.02528 9.94521 1.99958 10.0754 2 10.2067V12.9998C2 13.2651 2.10535 13.5194 2.29289 13.707C2.48043 13.8945 2.73478 13.9998 3 13.9998H13.5C13.6326 13.9998 13.7598 13.9472 13.8536 13.8534C13.9473 13.7596 14 13.6325 14 13.4998C14 13.3672 13.9473 13.2401 13.8536 13.1463C13.7598 13.0525 13.6326 12.9998 13.5 12.9998H7.2075L14.2075 5.99985C14.3004 5.90699 14.3741 5.79674 14.4243 5.6754C14.4746 5.55406 14.5005 5.424 14.5005 5.29266C14.5005 5.16132 14.4746 5.03127 14.4243 4.90992C14.3741 4.78858 14.3004 4.67834 14.2075 4.58547ZM5.79312 12.9998H3V10.2067L8.5 4.70672L11.2931 7.49985L5.79312 12.9998ZM12 6.79297L9.2075 3.99985L10.7075 2.49985L13.5 5.29297L12 6.79297Z" fill={color} />
    </svg>
  )
}

IconEdit.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
}

export default IconEdit;
